import { Button, Col, Form, Row } from "antd";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
import { fileToformData, validateInput } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";
import { useState } from "react";
import { errorMessage } from "../../../../tools/toastifyShowMessage";

const Document = ({ t, creditCard, setCreditCard }) => {
	const [frmDocument] = Form.useForm();
	const { uploadBankCardProfileFile, uploadBankCardContractFile } = useDealer();
	const [document, setDocument] = useState({ buttonProgress: false });

	const handleGetImage = (fieldName, value) => {
		frmDocument.setFieldValue(fieldName, value);
	};

	const submitHandler = async () => {
		try {
			const values = await frmDocument.validateFields();
			const profileid = creditCard?.profileId;

			if (!profileid) {
				errorMessage("شناسه پروفایل یافت نشد. لطفاً مرحله پروفایل را کامل کنید.");
				return;
			}

			setDocument((p) => ({ ...p, buttonProgress: true }));

			const docTypes = [
				"passport",
				//  "residence",
				"contract_moneytolia",
			];
			const uploadResults = {}; // ⬅️ خروجی همه آپلودها اینجا جمع می‌شود

			for (const docType of docTypes) {
				const val = values?.[docType];
				if (!val) continue;

				const params = await fileToformData(val);
				if (!params) {
					errorMessage(`فایل ${docType} معتبر نیست.`);
					setDocument((p) => ({ ...p, buttonProgress: false }));
					return;
				}

				// انتخاب سرویس مناسب و ذخیره خروجی
				const res =
					docType === "contract_moneytolia"
						? await uploadBankCardContractFile(docType, profileid, params)
						: await uploadBankCardProfileFile(docType, profileid, params);

				if (res == null) {
					errorMessage(`آپلود ${docType} با خطا مواجه شد.`);
					setDocument((p) => ({ ...p, buttonProgress: false }));
					return;
				}

				uploadResults[docType] = res?.Result; // ⬅️ خروجی این آپلود
			}

			// انتقال هم داده‌های فرم و هم خروجی سرویس‌ها
			setCreditCard((prev) => ({
				...prev,
				documents: { ...values },
				uploadResponses: { ...uploadResults }, // ⬅️ این‌جاست
				step: 3,
			}));
		} catch (err) {
			console.error(err);
		} finally {
			setDocument((p) => ({ ...p, buttonProgress: false }));
		}
	};
	return (
		<>
			<div className="g-body-format-page">
				<h3 className="header-of-form">آپلود مدارک</h3>
				<div className="holder-form">
					<Form id="frmDocument" name="frmDocument" form={frmDocument} onFinish={submitHandler} layout="vertical">
						<Row gutter={30}>
							<Col xs={24} sm={12} md={24} lg={12} xl={10}>
								<Form.Item name="passport" rules={[validateInput({ t, validate: true, type: "image" })]} label="آپلود پاسپورت">
									<ResizeImage exportImage={(v) => handleGetImage("passport", v)} />
								</Form.Item>
							</Col>
							<Col span={9} style={{ margin: "auto 0" }}>
								<ul>
									<li>بارگذاری پاسپورت با حداقل ۶ ماه اعتبار</li>
									<li>فرمت‌ها، حجم و رزولوشن قابل قبول</li>
									<li>گوشه‌های تصویر واضح و کامل باشد</li>
								</ul>
							</Col>
						</Row>

						{/* <Row gutter={30}>
							<Col xs={24} sm={12} md={24} lg={12} xl={10}>
								<Form.Item name="residence" rules={[validateInput({ t, validate: true, type: "image" })]} label="آپلود آدرس">
									<ResizeImage exportImage={(v) => handleGetImage("residence", v)} />
								</Form.Item>
							</Col>
							<Col span={10} style={{ margin: "auto 0" }}>
								<ul style={{ textAlign: "justify" }}>
									<li>مثال: قبض یا مدرک احراز آدرس</li>
									<li>فرمت‌ها، حجم و رزولوشن قابل قبول</li>
									<li>گوشه‌های تصویر واضح و کامل باشد</li>
								</ul>
							</Col>
						</Row> */}

						<Row gutter={30}>
							<Col xs={24} sm={12} md={24} lg={12} xl={10}>
								<Form.Item name="contract_moneytolia" rules={[validateInput({ t, validate: true, type: "image" })]} label="آپلود قرارداد">
									<ResizeImage exportImage={(v) => handleGetImage("contract_moneytolia", v)} />
								</Form.Item>
							</Col>
							<Col span={10} style={{ margin: "auto 0" }}>
								<ul style={{ textAlign: "justify" }}>
									<li>بارگذاری قرارداد</li>
									<li>فرمت‌ها، حجم و رزولوشن قابل قبول</li>
									<li>گوشه‌های تصویر واضح و کامل باشد</li>
								</ul>
							</Col>
						</Row>
					</Form>
				</div>
			</div>

			<div className="g-footer-format-page">
				<div className="holder-button">
					{/* ✅ دکمه submit به فرم درست وصل شد */}
					<Button className="btn-normal btn-aptel" type="primary" loading={document.buttonProgress} htmlType="submit" form="frmDocument">
						مرحله بعد
					</Button>

					<Button type="default" className="btn-normal " onClick={() => setCreditCard({ ...creditCard, step: 1 })}>
						بازگشت
					</Button>
				</div>
			</div>
		</>
	);
};

export default Document;
